<template>
    <div class="dev-list">
        <div class="dev-list-search">
            <div class="search-btn">
                <el-button size="small" type="primary" @click="addGroupPopShow = true"
                    v-if="$store.getters.checkChangeAuth() && $store.state.isAdmin">新增分组
                </el-button>
                <div></div>
                <div @keyup.enter="getGroupListForSearch">
                    <el-input size="small" placeholder="输入分组名称 搜索" v-model="searchInfo.groupNameLike"
                        style="width: 230px">
                        <el-button slot="append" icon="el-icon-search" @click="getGroupListForSearch"></el-button>
                    </el-input>
                </div>
            </div>
        </div>
        <div class="device-case-dev border-all">
            <el-table ref="multipleTable" :height="tableHeight" :data="info.list"
                :header-cell-style="{ backgroundColor: '#efefef' }" stripe size="mini" @row-click="goGroupDev"
                tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column type="index" label="ID"></el-table-column>
                <el-table-column prop="groupName" label="分组名称"></el-table-column>
                <el-table-column label="组内设备数量">
                    <template slot-scope="scope">
                        {{ scope.row.deviceNum || 0 }}
                    </template>
                </el-table-column>
                <el-table-column prop="appNum" label="组内应用数量"></el-table-column>
                <el-table-column label="操作" min-width="200px">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click.stop="manage(scope.row)"
                            v-if="$store.getters.checkChangeAuth() && $store.state.isAdmin">增减设备
                        </el-button>
                        <el-button type="text" size="small" @click.stop="goGroupDev(scope.row)">组内设备</el-button>
                        <el-button type="text" size="small" @click.stop="goAppManage(scope.row)">应用管理</el-button>
                        <el-button type="text" size="small" @click.stop="confirmChangeGroupName(scope.row)"
                            v-if="$store.getters.checkChangeAuth() && $store.state.isAdmin">编辑
                        </el-button>
                        <el-button type="text" size="small" @click.stop="goLog(scope.row)"
                            v-if="$store.getters.checkChangeAuth() && $store.state.isAdmin">日志监控
                        </el-button>
                        <el-button type="text" size="small" @click.stop="deleteDev(scope.row.id)"
                            v-if="$store.getters.checkChangeAuth() && $store.state.isAdmin">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="list-bottom">
                <div class="list-bottom-btn">
                </div>
                <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle"
                    :current-page="page.startPage" :page-sizes="[10, 20, 50]" :page-size="page.limit" :pager-count="5"
                    layout="total, sizes, prev, pager, next" :total="info.total">
                </el-pagination>
            </div>
            <!-- 新增分组弹窗 -->
            <Drawer title="新增分组" :visible.sync="addGroupPopShow" @handClick="addGroup">
                <div style="font-size: 12px">
                    <el-form ref="form" :model="addGroupInfo" label-width="130px" label-position="left"
                        style="display: flex;flex-direction: column;height: 100%">
                        <el-form-item size="mini" label="分组名称">
                            <el-input size="mini" v-model="addGroupInfo.groupName"></el-input>
                        </el-form-item>
                        <el-form-item size="mini" label="预设虚拟化数量" v-if="virtMumList.length > 0">
                            <el-select v-model="addGroupInfo.containerNum" size="small" style="width: 120px;">
                                <el-option v-for="item in virtMumList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <el-tooltip effect="dark" placement="bottom">
                                <div slot="content">预设虚拟化数量指1台云手机虚拟化后最终可获得的容器云机数量。<br />
                                    例如选择为2时，1台云手机最终可获得1台宿主云机和2台容器云机，<br />
                                    即云机一分三。
                                </div>
                                <div class="question-icon">?</div>
                            </el-tooltip>
                        </el-form-item>
                    </el-form>
                </div>
            </Drawer>

            <!-- 修改分组弹窗 -->
            <Drawer title="修改分组名称" :visible.sync="changeGroupPopShow" @handClick="changeGroupName">
                <div>
                    <el-form ref="form" :model="changeGroupInfo" label-width="130px" label-position="left">
                        <el-form-item size="mini" label="分组名称">
                            <el-input v-model="changeGroupInfo.groupName"></el-input>
                        </el-form-item>
                        <el-form-item size="mini" label="预设虚拟化数量" v-if="virtMumList.length > 0">
                            <el-select v-model="changeGroupInfo.containerNum" size="small" style="width: 120px;"
                                disabled>
                                <el-option v-for="item in virtMumList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
            </Drawer>
        </div>

        <!-- 上传文件 -->
        <Drawer title="上传文件" :visible.sync="uploadFilePopShow" @handClick="submitUpload" :before-close="popClose">
            <div>
                <el-form ref="form" :model="uploadFileExtraInfo" label-width="130px" label-position="left">
                    <el-form-item>
                        <el-upload class="upload-demo" ref="upload" :headers="$store.getters.getHeaders"
                            :action="$uri.group.uploadConfigureFile" :data="uploadFileExtraInfo" :multiple="true"
                            :on-success="handleSuccess" :before-upload="handleUpload" :on-progress="handleProgress"
                            :auto-upload="false">
                            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
            </div>
        </Drawer>
    </div>
</template>

<script>
import Drawer from '@/components/Drawer'
import { commonData } from '@/mixin'
export default {
    name: "GroupList",
    components: {
        Drawer
    },
    mixins: [commonData],
    data() {
        return {
            virtDevNum: 0,
            virtMumList: [],

            addGroupPopShow: false, // 显示添加分组弹窗
            addGroupAuthSelectShow: false,
            addGroupInfo: {
                groupName: "",
                isAppAllow: "0",
                isInstallApp: "1",
                isUninstallApp: "1",
                isHome: "1",
                containerNum: "0"
            },
            delGroupPopShow: false, // 显示删除分组弹窗
            changeGroupPopShow: false, // 显示修改分组名称弹窗
            changeGroupInfo: {
                id: 0,
                groupName: '',
                isAppAllow: '',
                isInstallApp: "",
                isUninstallApp: "",
                isHome: "",
                containerNum: ""
            },
            changeGroupAuthPopShow: false, // 显示修改分组名称弹窗
            uploadFilePopShow: false,
            uploadFileExtraInfo: {
                id: 0
            },
            searchInfo: {
                groupNameLike: ""
            },
            uploadPopCloseTip: false
        }
    },
    computed: {},
    methods: {
        checkLicenseService(index) {
            let found = -1
            if (this.$store.state.licenseInfo && this.$store.state.licenseInfo.service) {
                let serviceItems = this.$store.state.licenseInfo.service.toString().split(",")
                // console.log("serviceItems is " + JSON.stringify(serviceItems))
                serviceItems.forEach(item => {
                    // console.log("item is " + item + ", index is " + index)
                    if (item == index) {
                        found = 1
                        return
                    }
                })
            }
            return found
        },

        initContainerMaxNum() {
            this.virtMumList = []
            if (this.$store.state.licenseInfo && (!this.$store.state.licenseInfo.hasOwnProperty("isNew") || this.$store.state.licenseInfo.isNew == 0)) {
                if (this.checkLicenseService(10) !== -1) {
                    this.virtMumList = [{
                        label: 0,
                        value: 0
                    }, {
                        label: 1,
                        value: 1
                    },
                    ]
                } else if (this.checkLicenseService(11) !== -1) {
                    this.virtMumList = [{
                        label: 0,
                        value: 0
                    }, {
                        label: 1,
                        value: 1
                    },
                    {
                        label: 2,
                        value: 2
                    },
                    ]
                } else if (this.checkLicenseService(12) !== -1) {
                    this.virtMumList = [{
                        label: 0,
                        value: 0
                    }, {
                        label: 1,
                        value: 1
                    },
                    {
                        label: 2,
                        value: 2
                    },
                    {
                        label: 3,
                        value: 3
                    }
                    ]
                }
            } else {
                if (this.$store.state.licenseInfo && this.$store.state.licenseInfo.isNew == 1 && this.$store.state.licenseInfo.service) {
                    if (this.checkLicenseService(10) !== -1) {
                        this.$store.state.licenseInfo.serviceForever.forEach(service => {
                            if (parseInt(service.serviceNo) == 10) {
                                if (service.max == 1) {
                                    this.virtMumList = [{
                                        label: 0,
                                        value: 0
                                    }, {
                                        label: 1,
                                        value: 1
                                    },
                                    ]
                                } else if (service.max == 2) {
                                    this.virtMumList = [{
                                        label: 0,
                                        value: 0
                                    }, {
                                        label: 1,
                                        value: 1
                                    },
                                    {
                                        label: 2,
                                        value: 2
                                    },
                                    ]
                                } else if (service.max == 3) {
                                    this.virtMumList = [{
                                        label: 0,
                                        value: 0
                                    }, {
                                        label: 1,
                                        value: 1
                                    },
                                    {
                                        label: 2,
                                        value: 2
                                    },
                                    {
                                        label: 3,
                                        value: 3
                                    }
                                    ]
                                }
                            }
                        })
                    }
                }
            }
        },
        /* 表单击行事件 */
        checkRow(r, c, e) {
            this.$refs.multipleTable.toggleRowSelection(r)
        },
        /* 获取选中的数据 */
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        /* 获取分组列表 */
        getGroupList() {
            this.$post(this.$uri.group.list, { ...this.page, ...this.searchInfo }).then(res => {
                // console.log("getGroupList res " + JSON.stringify(res))
                this.info = res
                if (!this.$store.state.isAdmin && this.$store.state.loginNow) {
                    this.$store.commit(this.$mutation.LOGIN_NOW, false)
                    if (res.list.length === 1) {
                        this.goGroupDev(this.info.list[0])
                    }
                }
                this.$nextTick().then(() => {
                    if (this.$refs.multipleTable) {
                        this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
                    }
                })
            })
        },
        getGroupListForSearch() {
            this.page.startPage = 1
            this.$post(this.$uri.group.list, { ...this.page, ...this.searchInfo }).then(res => {
                // console.log("getGroupList res " + JSON.stringify(res))
                this.info = res
                if (!this.$store.state.isAdmin && this.$store.state.loginNow) {
                    this.$store.commit(this.$mutation.LOGIN_NOW, false)
                    if (res.list.length === 1) {
                        this.goGroupDev(this.info.list[0])
                    }
                }
                this.$nextTick().then(() => {
                    if (this.$refs.multipleTable) {
                        this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
                    }
                })
            })
        },
        /* 当前页改变 */
        currentChangeHandle(val) {
            this.page.startPage = val
            this.getGroupList()
        },
        /* 每页条数改变 */
        sizeChangeHandle(val) {
            this.page.limit = val
            this.getGroupList()
        },
        /* 新增分组 */
        addGroup() {
            let that = this
            that.$post(that.$uri.group.add, that.addGroupInfo).then(res => {
                that.$message.success("新建分组成功")
                that.addGroupPopShow = false
                that.getGroupList()
            })
        },
        /* 删除分组确认 */
        confirmDelGroup(row) {
            this.$confirm("确认删除分组-" + row.groupName + "?", "提示", {
                confirmButtonText: '确定',
                confirmButtonClass: 'confirm-btn-blue',
                iconClass: 'el-icon-c-blue',
                cancelButtonText: '取消'
            }).then(() => {
                this.delGroup(row.id)
            }).catch(() => {
            })
        },
        /* 删除分组 */
        delGroup(id) {
            let that = this
            that.$post(that.$uri.group.delete, { id }).then(res => {
                that.$message.success("删除分组成功")
                that.getGroupList()
            })
        },
        /* 确认修改分组名称 */
        confirmChangeGroupName(row) {
            this.changeGroupInfo.id = row.id
            this.changeGroupInfo.groupName = row.groupName
            this.changeGroupInfo.isAppAllow = row.isAppAllow
            this.changeGroupInfo.isInstallApp = row.isInstallApp
            this.changeGroupInfo.isUninstallApp = row.isUninstallApp
            this.changeGroupInfo.isHome = row.isHome
            this.changeGroupInfo.containerNum = row.containerNum
            this.changeGroupPopShow = true
        },
        /* 修改分组名 */
        changeGroupName() {
            let that = this
            that.$post(that.$uri.group.infoSave, that.changeGroupInfo).then(res => {
                that.$message.success("修改成功")
                that.changeGroupPopShow = false
                that.getGroupList()
            })
        },
        /* 权限控制弹窗 */
        changeGroupAuthPop(row) {
            this.$store.commit(this.$mutation.GROUP_DETAIL, row)
            this.$router.push("/home/group/auth")
        },
        /* 权限控制 */
        changeGroupAuth() {
            let that = this
            that.$post(that.$uri.group.infoSave, that.changeGroupInfo).then(res => {
                that.$message.success("修改成功")
                that.changeGroupAuthPopShow = false
                that.getGroupList()
            })
        },
        goLog(row) {
            this.$store.commit(this.$mutation.LOG_GROUP_ID, row.groupName)
            this.$router.push("/home/log/group")
        },
        /* 上传文件弹窗 */
        uploadFilePop(id) {
            this.uploadFileExtraInfo.id = id
            this.uploadFilePopShow = true
        },
        popClose() {
            if (this.uploadPopCloseTip) {
                this.$confirm("文件正在上传中，确定关闭弹窗？", "提示", {
                    confirmButtonText: '确定',
                    confirmButtonClass: 'confirm-btn-blue',
                    iconClass: 'el-icon-c-blue',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.uploadFilePopShow = false
                    this.uploadPopCloseTip = false
                    this.$refs.upload.clearFiles()
                }).catch(() => {
                })
            } else {
                this.uploadFilePopShow = false
                this.uploadPopCloseTip = false
                this.$refs.upload.clearFiles()
            }
        },
        /* 上传文件 */
        submitUpload() {
            this.$refs.upload.submit();
        },
        handleSuccess(response, file, fileList) {
            // console.log("response is " + JSON.stringify(response))
            // console.log("file is " + JSON.stringify(file))
            // console.log("fileList is " + JSON.stringify(fileList))
            if (response.success) {
                let allDone = true
                fileList.forEach(item => {
                    if (item.percentage != 100) {
                        allDone = false
                    }
                })
                if (allDone) {
                    this.uploadFilePopShow = false
                    this.uploadPopCloseTip = false
                    this.$refs.upload.clearFiles()
                    this.$message.success("上传成功")
                }
            } else {
                this.$message.error(response.message)
                this.$refs.upload.clearFiles()
            }
        },
        handleUpload() {
            this.uploadPopCloseTip = true
        },
        handleProgress(event, file, fileList) {
            if (!this.uploadFilePopShow) {
                this.$refs.upload.abort(file)
                this.$refs.upload.clearFiles()
            }
        },
        /* 删除设备池 */
        deleteDev(id) {
            this.$confirm("删除分组后会导致分组内的设备恢复出厂设置，清除数据，是否继续？", "提示", {
                confirmButtonText: '确定',
                confirmButtonClass: 'confirm-btn-red',
                iconClass: 'el-icon-c-red',
                cancelButtonText: '取消'
            }).then(() => {
                let that = this
                that.$post(that.$uri.group.delete, { id }).then(res => {
                    if (res.success) {
                        that.$message.success("删除完成")
                        setTimeout(() => {
                            that.getGroupList()
                        }, 1000)
                    } else {
                        that.$message.error("删除失败")
                    }
                })
            }).catch(() => {
            })
        },
        /* 管理 */
        manage(info) {
            this.$store.commit(this.$mutation.GROUP_DETAIL, info)
            this.$router.push("/home/group/dev/manage")
        },
        /* 跳转组内设备 */
        goGroupDev(info) {
            // console.log("info is ", JSON.stringify(info))
            this.$store.commit(this.$mutation.GROUP_DETAIL, info)
            this.$router.push("/home/group/dev")
        },
        /* 跳转应用管理 */
        goAppManage(info) {
            this.$store.commit(this.$mutation.GROUP_DETAIL, info)
            this.$router.push("/home/group/app/manage")
        }
    },
    filters: {},
    beforeMount() {
        this.initContainerMaxNum()
    },
    mounted() {
        this.getGroupList()
    }
};
</script>

<style lang="less" scoped>
.dev-list {
    .dev-list-search {
        width: 100%;
        display: flex;
        flex-direction: column;

        .search-btn {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }

        .search-advanced {
            display: flex;
            flex-direction: column;

            .search-main {
                margin-top: 10px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                flex-wrap: wrap;

                .search-main-item {
                    width: 24%;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    /*flex-grow: 1;*/
                    padding: 5px 10px;

                    span {
                        font-size: 12px;
                    }

                    .item-input {
                        width: 180px;
                    }
                }
            }

            .search-btn {
                padding: 0 10px;
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;
            }
        }
    }

    .device-case-dev {
        margin-top: 10px;

        .list-bottom {
            padding: 10px 8px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .list-bottom-btn {
                display: flex;
                flex-direction: row;
            }
        }
    }
}

.question-icon {
    margin-left: 5px;
    width: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    border-radius: 50%;
    background-color: grey;
    color: white;
    display: inline-block;
    position: relative;
}
</style>